import {DEFAULT_DURATION} from 'nav/toasts/ToastConstants';
import notifications from 'notifications';
import {GENERIC_ERROR_MESSAGE} from 'ui-library/ErrorConstants';

export const GENERIC_GRAPHQL_ERROR_ID = 'graphql-generic-error';

/**
 * GraphQL sometimes has a tendency of sending a large number of error toasts (network failures can cause
 * several queries to alert all at once).  Since these error toasts are not auto-dismissing, they tend to
 * accumulate to fill the entirety of the user's window.  This degrades the user experience significantly
 * without providing insight into how to address these issues since the error message is generic.
 *
 * We should investigate the underlying cause of repeated errors, but while that investigation is ongoing we
 * should mitigate the negative impact to the user in the meantime.
 *
 * By providing an error id we deduplicate generic GraphQL errors in the notifications system, which should
 * limit the impact on the user to buy us some time for more robust fixes.
 *
 * See https://benchling.quip.com/NFOwAbx6TqZW/2021-05-12-Handling-GraphQL-red-toast-spam for more details.
 */
export default function notifyGenericGraphQLError(message?: string): void {
  notifications.error(message ?? GENERIC_ERROR_MESSAGE, {
    id: GENERIC_GRAPHQL_ERROR_ID,
    duration: DEFAULT_DURATION,
  });
}
